import RuleTemplate from "@/components/ai-consumer-research/brand-moderator/rules/rule-template";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ChevronLeft } from "lucide-react";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/rules/")({
  component: RulesIndex,
});

function RulesIndex() {
  return (
    <section className="p-4">
      <div className="flex items-center gap-2 mb-6">
        <Link to="/dashboard/consumer-research/brand-moderator" className="text-sm text-muted-foreground hover:text-foreground">
          <ChevronLeft size={20} />
        </Link>
        <h2 className="text-lg font-semibold text-foreground">Create Rule</h2>
      </div>
      <RuleTemplate />
    </section>
  );
}
